// Thin client for the presets API. All calls need the session cookie, so
// every fetch here uses credentials: 'include'.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

async function parseErrorMessage(res) {
  try {
    const data = await res.json();
    return data.detail || data.message || `Request failed (${res.status})`;
  } catch (e) {
    return `Request failed (${res.status})`;
  }
}

export async function listPresets() {
  const res = await fetch(`${API}/presets`, { credentials: 'include' });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json(); // [{ id, name, settings }]
}

export async function createPreset(name, settings) {
  const res = await fetch(`${API}/presets`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ name, settings }),
  });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json(); // { id, name, settings }
}

export async function deletePreset(id) {
  const res = await fetch(`${API}/presets/${id}`, { method: 'DELETE', credentials: 'include' });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json();
}
